/**
 * Format plan name for display
 * Maps "Free Plan" to "Base Plan" for better user experience
 *
 * @param {string} planName - The original plan name
 * @returns {string} - The formatted plan name
 */
export const formatPlanName = (planName) => {
  if (!planName) return '';

  // Convert "Free Plan" to "Base Plan"
  if (planName.toLowerCase() === 'free plan') {
    return 'Base Plan';
  }

  return planName;
};

/**
 * Check if a plan is the free/base plan
 *
 * @param {string} planName - The plan name to check
 * @returns {boolean} - True if it's the free/base plan
 */
export const isFreePlan = (planName) => {
  if (!planName) return false;
  return planName.toLowerCase() === 'free plan';
};
